import { render, staticRenderFns } from "./InceptionAssessmentWrapper.vue?vue&type=template&id=7d538c82&scoped=true"
import script from "./InceptionAssessmentWrapper.vue?vue&type=script&lang=ts"
export * from "./InceptionAssessmentWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d538c82",
  null
  
)

export default component.exports